import React from "react";
import { CompanyForContactDetails } from "./CompanyForContactDetails";

interface ContactWorksAtPreviewPanelProps {
  worksAt: server.dto.CompanyWithWorkRelation[]
}

export const ContactWorksAtSection = ({ worksAt }: ContactWorksAtPreviewPanelProps) => {
  if (worksAt.length === 0) {
    return null;
  }

  return <div className="flex-column gap">
    <div className="nav-text-regular">{RESX.GeneralLabels.WorksAt}</div>
    {worksAt.map(companyWithWorkRelation => <CompanyForContactDetails key={companyWithWorkRelation.company.companyId} company={companyWithWorkRelation} />)}
  </div>
}